exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-down[data-v-c87d19e8]{color:#1684fc;text-decoration:underline}", ""]);

// exports
